import React from 'react';
import Icon from '.';

const ChevronDownIcon = props => (
	<Icon {...props} viewBox="0 0 16 10">
		<polyline
			stroke="currentColor"
			strokeWidth="3"
			fill="none"
			transform="translate(8, 5.5) rotate(90) translate(-8, -5.5)"
			points="4.5 -1.5 11.5 5.5 4.5 12.5"
		/>
	</Icon>
);

export default ChevronDownIcon;
